export default function AppDownloadCTA() {
  return (
    <section id="app-download" className="relative w-full py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20smartphone%20on%20dark%20elegant%20surface%20with%20warm%20coral%20and%20gold%20abstract%20light%20leaks%2C%20luxury%20tech%20atmosphere%2C%20dramatic%20cinematic%20lighting%2C%20dark%20background%20with%20soft%20gradients%2C%20professional%20product%20photography%2C%20no%20text%2C%20minimalist%20composition&width=1800&height=800&seq=cta-app-download-bg&orientation=landscape"
          alt="52吃瓜网App下载"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          {/* Left: Title */}
          <div className="flex-shrink-0">
            <h2
              className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              下载 52吃瓜网 App
              <br />
              大瓜不错过
            </h2>
          </div>

          {/* Right: Description & Button */}
          <div className="flex flex-col items-end gap-6">
            <p className="text-background-200 text-base md:text-lg leading-relaxed max-w-sm text-right">
              随时随地掌握最新吃瓜动态
              <br />
              推送通知秒速提醒，大瓜一个不落
            </p>
            <a
              href="#"
              className="whitespace-nowrap inline-flex items-center gap-3 px-8 py-4 bg-background-50 text-foreground-900 rounded-full text-base font-medium hover:bg-background-100 transition-all hover:scale-105 cursor-pointer"
            >
              立即下载
              <span className="w-8 h-8 flex items-center justify-center bg-foreground-900 text-background-50 rounded-full">
                <i className="ri-arrow-right-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}